import { getSession } from "./../supabase/supabaseClient";

export const isLoggedIn = async () => {
  const session = await getSession();
  return session;
};
